<script>
export default {
  name: 'CurrentSessionMixin',
  computed: {
    currentLogin () {
      return this.$store.getters['auth/login']
    },
    currentCompany () {
      const companyId = this.$store.getters['auth/companyId']
      return this.$store.getters['companies/companyName'](companyId)
    },
    currentCompaniesList () {
      return this.$store.getters['companies/companiesList']
    },
    currentRole () {
      return this.$store.getters['auth/role']
    },
    currentAdminRoleId () {
      const current = this.$store.getters['entitlements/currentAdminRoleId'](this.currentLogin)
      return current ? current.id : null
    },
    currentEnvironment () {
      return this.$store.state.auth.server
    },
    originalCompany () {
      const companyId = this.$store.getters['auth/originalCompanyId']
      return this.$store.getters['companies/companyName'](companyId)
    },
    isImbellusUser () {
      return this.originalCompany === 'Imbellus'
    },
    isImbellusCompany () {
      return this.currentCompany === 'Imbellus'
    },
    isProduction () {
      return this.currentEnvironment === 'pd'
    }
  }
}
</script>
